export const heroData = {
  tag: '🎬 每日更新 · 高清不卡顿',
  title: '无极电影网',
  subtitle: '海量影视资源 · 极速流畅观影',
  description: '无极电影网是国内领先的免费影视在线观看平台，汇集全网最新高清电影、热门电视剧、经典综艺和人气动漫，覆盖国产剧、欧美大片、日韩热剧等全品类内容。采用智能CDN加速与自适应码率技术，确保播放不缓冲、零卡顿，无论电脑还是手机都能畅享蓝光画质。站内每日更新最新片源，热门影视第一时间同步上线，追剧无需等待。',
  stats: [
    { label: '日更新片源', value: '300+' },
    { label: '高清覆盖率', value: '99%' },
    { label: '月活跃用户', value: '800万+' },
  ],
  primaryCta: { label: '立即观影', href: '#ranking' },
  secondaryCta: { label: '下载APP', href: '#app' },
};

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20Chinese%20man%20with%20friendly%20smile%2C%20simple%20studio%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '影迷小李',
    time: '2小时前',
    content: '无极电影网的画质真的绝了！最近追的《狂飙》全程蓝光不卡顿，比我在其他站看流畅太多了。而且更新速度超快，朋友刚跟我说新一集出了，这边就已经能看了。强烈推荐给所有追剧党！',
    rating: 5,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20natural%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '追剧达人',
    time: '5小时前',
    content: '用了半年多了，从没遇到过缓冲的情况。片库也全，想看的老片新片几乎都有，分类也很清晰。最满意的是手机端体验，地铁上刷剧画质照样清晰流畅，通勤时间再也不无聊了。',
    rating: 5,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20a%20middle%20aged%20Chinese%20man%2C%20professional%20look%2C%20simple%20background%2C%20warm%20lighting%2C%20headshot%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '影视爱好者',
    time: '1天前',
    content: '作为一个电影发烧友，这个站的片源质量让我很惊喜。很多冷门文艺片和经典老片都能找到高清版本，而且居然支持蓝光画质。不用注册就能看，没有任何套路，真的是良心平台。',
    rating: 5,
  },
];

export const mediaData = [
  {
    id: 1,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20scene%20with%20dramatic%20lighting%2C%20Chinese%20film%20aesthetic%2C%20dark%20moody%20atmosphere%20with%20golden%20highlights%2C%20film%20grain%20texture%2C%20cinematic%20composition&width=640&height=360&seq=media-01&orientation=landscape',
    title: '《流浪地球3》终极预告',
    tag: '热播',
    views: '128万',
    duration: '02:45',
  },
  {
    id: 2,
    cover: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20historical%20drama%20scene%2C%20ancient%20palace%20interior%2C%20warm%20candle%20lighting%2C%20rich%20textures%2C%20cinematic%20color%20grading%2C%20film%20aesthetic&width=640&height=360&seq=media-02&orientation=landscape',
    title: '《长安十二时辰》精彩片段',
    tag: '推荐',
    views: '96万',
    duration: '05:12',
  },
  {
    id: 3,
    cover: 'https://readdy.ai/api/search-image?query=modern%20Chinese%20urban%20drama%20scene%2C%20city%20night%20setting%2C%20neon%20lights%2C%20cinematic%20composition%2C%20moody%20atmosphere%2C%20film%20grading%20with%20teal%20and%20orange%20tones&width=640&height=360&seq=media-03&orientation=landscape',
    title: '《繁花》沪上风情特辑',
    tag: '热门',
    views: '85万',
    duration: '03:28',
  },
  {
    id: 4,
    cover: 'https://readdy.ai/api/search-image?query=sci-fi%20movie%20scene%20with%20futuristic%20cityscape%2C%20cyberpunk%20aesthetic%2C%20dramatic%20lighting%2C%20cinematic%20color%20grading%2C%20large%20scale%20visual%20effects%2C%20film%20quality&width=640&height=360&seq=media-04&orientation=landscape',
    title: '《三体》世界观解析',
    tag: '深度',
    views: '76万',
    duration: '08:30',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '狂飙', type: '电视剧', year: '2023', rating: '9.5', hot: '🔥 热播中', change: 'up', cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20movie%20poster%2C%20dark%20atmospheric%2C%20two%20men%20in%20tense%20standoff%2C%20cinematic%20lighting%2C%20minimal%20composition%2C%20film%20poster%20style&width=200&height=280&seq=ranking-01&orientation=portrait' },
  { id: 2, rank: 2, title: '庆余年第二季', type: '电视剧', year: '2024', rating: '9.3', hot: '🔥 新番', change: 'up', cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20elegant%20ancient%20costume%2C%20mystical%20atmosphere%2C%20warm%20golden%20lighting%2C%20film%20poster%20aesthetic&width=200&height=280&seq=ranking-02&orientation=portrait' },
  { id: 3, rank: 3, title: '流浪地球2', type: '电影', year: '2023', rating: '9.2', hot: '💎 蓝光', change: 'same', cover: 'https://readdy.ai/api/search-image?query=sci-fi%20movie%20poster%2C%20astronaut%20facing%20giant%20planet%2C%20epic%20scale%2C%20blue%20and%20orange%20cinematic%20lighting%2C%20film%20poster%20design&width=200&height=280&seq=ranking-03&orientation=portrait' },
  { id: 4, rank: 4, title: '长相思', type: '电视剧', year: '2023', rating: '9.1', hot: '📈 上升', change: 'up', cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%2C%20ethereal%20beauty%20in%20flowing%20dress%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20film%20poster%20style&width=200&height=280&seq=ranking-04&orientation=portrait' },
  { id: 5, rank: 5, title: '封神第一部', type: '电影', year: '2023', rating: '9.0', hot: '🏆 口碑', change: 'up', cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20warriors%20in%20ancient%20armor%2C%20grand%20battle%20scene%2C%20dramatic%20lighting%2C%20film%20poster%20aesthetic&width=200&height=280&seq=ranking-05&orientation=portrait' },
  { id: 6, rank: 6, title: '莲花楼', type: '电视剧', year: '2023', rating: '8.9', hot: '🆕 上新', change: 'down', cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%2C%20swordsman%20in%20bamboo%20forest%2C%20misty%20atmosphere%2C%20elegant%20composition%2C%20film%20poster%20design&width=200&height=280&seq=ranking-06&orientation=portrait' },
];

export const faqData = [
  {
    id: 1,
    question: '无极电影网的视频需要付费吗？',
    answer: '完全不需要！无极电影网所有影视内容均为免费在线观看，无需注册、无需付费、无需VIP会员。我们致力于为影迷提供零门槛的优质观影体验，从热门新片到经典老片，从国产剧到海外大片，全部免费畅享。',
  },
  {
    id: 2,
    question: '为什么你们的视频播放不卡顿？',
    answer: '我们采用多节点CDN智能加速技术，在全国部署了数百个加速节点，系统会根据您的网络环境自动选择最优线路。同时支持自适应码率调节，在网络波动时自动切换清晰度，确保播放流畅不缓冲，真正实现零卡顿观影体验。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？画质如何？',
    answer: '无极电影网完美支持电脑、平板和手机端观看，页面采用响应式设计，自动适配不同屏幕尺寸。画质方面，大部分影片提供高清和蓝光两种清晰度选择，在网络条件良好时可直接享受蓝光级别的视觉盛宴。',
  },
  {
    id: 4,
    question: '影片更新频率怎么样？能第一时间看到新片吗？',
    answer: '我们的内容团队全天候追踪各大平台的最新片源，热门电视剧通常在播出后2小时内上线，电影大片上线速度在行业内保持领先。首页每日更新300+条片源信息，确保您不会错过任何精彩内容。',
  },
];

export const topicsData = [
  { id: 1, name: '流浪地球3', count: '128万讨论', color: 'accent' },
  { id: 2, name: '狂飙结局', count: '96万讨论', color: 'primary' },
  { id: 3, name: '庆余年第二季', count: '85万讨论', color: 'secondary' },
  { id: 4, name: '繁花沪语版', count: '72万讨论', color: 'accent' },
  { id: 5, name: '三体动画', count: '68万讨论', color: 'primary' },
  { id: 6, name: '封神第二部', count: '55万讨论', color: 'secondary' },
  { id: 7, name: '长相思ost', count: '49万讨论', color: 'accent' },
  { id: 8, name: '莲花楼打戏', count: '43万讨论', color: 'primary' },
  { id: 9, name: '科幻电影推荐', count: '38万讨论', color: 'secondary' },
  { id: 10, name: '悬疑剧天花板', count: '35万讨论', color: 'accent' },
  { id: 11, name: '国漫崛起', count: '31万讨论', color: 'primary' },
];

export const cardsData = [
  {
    id: 1,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20key%20visual%2C%20intense%20atmosphere%2C%20dark%20urban%20setting%2C%20cinematic%20lighting%2C%20film%20promotional%20image&width=400&height=240&seq=card-01&orientation=landscape',
    title: '《狂飙》全集在线免费看，扫黑大剧不卡顿',
    tag: '电视剧',
    desc: '张译、张颂文主演现象级扫黑剧，39集全',
  },
  {
    id: 2,
    cover: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20film%20visual%2C%20giant%20space%20station%20above%20earth%2C%20dramatic%20cinematic%20lighting%2C%20film%20promotional%20key%20art&width=400&height=240&seq=card-02&orientation=landscape',
    title: '《流浪地球2》蓝光画质免费看，科幻巨制',
    tag: '电影',
    desc: '吴京、刘德华领衔，国产科幻巅峰之作',
  },
  {
    id: 3,
    cover: 'https://readdy.ai/api/search-image?query=historical%20Chinese%20drama%20promotional%20image%2C%20elegant%20ancient%20scene%2C%20palace%20interior%20with%20warm%20candlelight%2C%20film%20quality&width=400&height=240&seq=card-03&orientation=landscape',
    title: '《庆余年第二季》高清全集，流畅不缓冲',
    tag: '电视剧',
    desc: '张若昀回归，年度最受期待古装大剧',
  },
  {
    id: 4,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20visual%2C%20ethereal%20landscape%20with%20floating%20mountains%2C%20dreamy%20color%20palette%2C%20film%20promotional%20art&width=400&height=240&seq=card-04&orientation=landscape',
    title: '《长相思》全集在线播放，古装神话巨制',
    tag: '电视剧',
    desc: '杨紫、张晚意主演，虐心仙侠神作',
  },
  {
    id: 5,
    cover: 'https://readdy.ai/api/search-image?query=mythological%20Chinese%20epic%20film%20key%20visual%2C%20ancient%20warriors%20in%20battle%2C%20grand%20scale%2C%20cinematic%20lighting%2C%20film%20promotional%20art&width=400&height=240&seq=card-05&orientation=landscape',
    title: '《封神第一部》蓝光免费在线，史诗巨制',
    tag: '电影',
    desc: '费翔、李雪健主演，东方神话视觉盛宴',
  },
  {
    id: 6,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20visual%2C%20swordsman%20in%20misty%20bamboo%20forest%2C%20elegant%20action%20pose%2C%20cinematic%20composition&width=400&height=240&seq=card-06&orientation=landscape',
    title: '《莲花楼》全集高清在线，武侠探案双绝',
    tag: '电视剧',
    desc: '成毅、曾舜晞主演，新派武侠口碑之作',
  },
  {
    id: 7,
    cover: 'https://readdy.ai/api/search-image?query=modern%20Chinese%20urban%20drama%20visual%2C%20Shanghai%20cityscape%20at%20night%2C%20neon%20lights%20reflection%2C%20cinematic%20mood&width=400&height=240&seq=card-07&orientation=landscape',
    title: '《繁花》沪语版全集，王家卫首部电视剧',
    tag: '电视剧',
    desc: '胡歌、马伊琍主演，上海滩风云故事',
  },
];

export const contactData = {
  title: '联系我们',
  description: '欢迎影迷朋友通过以下方式与我们联系。无论是片源建议、问题反馈还是商务合作，您的每一条信息我们都会认真对待。无极电影网始终坚持用户至上，持续优化观影体验。',
  email: 'feedback@wujimovie.com',
  wechat: 'wujimovie2024',
  qq: '800123456',
  hours: '客服时间：每日 9:00 - 24:00',
};

export const appData = {
  title: '移动观影',
  description: '下载无极电影网APP，随时随地畅享高清影视。支持离线缓存、画中画播放、投屏电视等功能，让观影体验更自由。海量影视资源装在口袋里，通勤路上、旅途间隙，好剧永不掉线。',
  features: ['蓝光画质', '离线下载', '投屏播放', '画中画', '倍速播放', '夜间模式'],
  platforms: [
    { name: 'Android', icon: 'ri-android-line' },
    { name: 'iOS', icon: 'ri-apple-line' },
    { name: 'Windows', icon: 'ri-windows-line' },
  ],
};

export const aboutData = {
  title: '关于无极电影网',
  description: '无极电影网成立于2020年，是国内领先的免费高清影视在线观看平台。我们秉承「让每个人都能自由享受影视之美」的理念，通过持续的技术创新和内容运营，为数千万影迷提供流畅、高清、免费的观影服务。',
  highlights: [
    { label: '片源总量', value: '10万+' },
    { label: '累计用户', value: '5000万+' },
    { label: '日均播放', value: '2000万+' },
    { label: '运营年限', value: '5年+' },
  ],
};

export const carouselData = [
  {
    id: 1,
    cover: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20sci-fi%20movie%20key%20visual%2C%20futuristic%20city%20with%20giant%20structures%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20film%20promotional%20banner&width=960&height=480&seq=carousel-01&orientation=landscape',
    title: '科幻巨制·流浪地球系列',
    desc: '中国科幻电影的里程碑之作，宏大的世界观与震撼的视觉特效，蓝光画质免费在线观看。',
    tag: '专题',
  },
  {
    id: 2,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20banner%2C%20grand%20ancient%20palace%20scene%2C%20golden%20warm%20lighting%2C%20cinematic%20film%20promotional%20art&width=960&height=480&seq=carousel-02&orientation=landscape',
    title: '古装大剧·庆余年系列',
    desc: '现象级古装权谋大剧，张若昀演绎范闲传奇，第二季热度再创新高。',
    tag: '专题',
  },
  {
    id: 3,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20banner%2C%20dark%20moody%20urban%20scene%2C%20two%20figures%20in%20tension%2C%20cinematic%20noir%20lighting%2C%20film%20promotional&width=960&height=480&seq=carousel-03&orientation=landscape',
    title: '悬疑犯罪·国产精品',
    desc: '《狂飙》《白夜追凶》《隐秘的角落》等口碑悬疑剧，烧脑剧情一次看过瘾。',
    tag: '专题',
  },
  {
    id: 4,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20banner%2C%20fantasy%20world%20with%20magical%20creatures%2C%20vibrant%20colors%2C%20cinematic%20animated%20film%20promotional%20art&width=960&height=480&seq=carousel-04&orientation=landscape',
    title: '国漫崛起·动画精选',
    desc: '《哪吒》《白蛇》《深海》等国产动画佳作，展现东方美学的独特魅力。',
    tag: '专题',
  },
  {
    id: 5,
    cover: 'https://readdy.ai/api/search-image?query=classic%20Hong%20Kong%20cinema%20banner%2C%20nostalgic%20film%20scene%2C%20warm%20vintage%20tones%2C%20cinematic%20film%20heritage%20art&width=960&height=480&seq=carousel-05&orientation=landscape',
    title: '经典重温·华语经典',
    desc: '周星驰喜剧、王家卫文艺、成龙动作，那些年我们追过的经典港片合集。',
    tag: '专题',
  },
];

export const indexData = [
  { id: 1, title: '国产剧专场', count: '2,860部', icon: 'ri-tv-line' },
  { id: 2, title: '欧美大片', count: '1,950部', icon: 'ri-film-line' },
  { id: 3, title: '日韩热剧', count: '1,420部', icon: 'ri-earth-line' },
  { id: 4, title: '动画动漫', count: '1,280部', icon: 'ri-emotion-line' },
  { id: 5, title: '综艺娱乐', count: '960部', icon: 'ri-live-line' },
  { id: 6, title: '纪录片', count: '750部', icon: 'ri-camera-line' },
  { id: 7, title: '经典老片', count: '1,100部', icon: 'ri-history-line' },
];

export const updatesData = [
  { id: 1, time: '2024年8月1日 14:30', title: '《庆余年第二季》第15-16集已更新上线', tag: '剧集更新' },
  { id: 2, time: '2024年8月1日 11:00', title: '《流浪地球3》幕后特辑独家上线，导演郭帆揭秘拍摄幕后', tag: '独家内容' },
  { id: 3, time: '2024年8月1日 08:00', title: '七夕观影专题「浪漫爱情电影合集」今日上线', tag: '专题上线' },
  { id: 4, time: '2024年7月31日 20:00', title: '《封神第一部》蓝光修复版上线，画质全面升级', tag: '画质升级' },
  { id: 5, time: '2024年7月31日 16:00', title: '系统维护完成，播放体验进一步优化，加载速度提升30%', tag: '系统公告' },
  { id: 6, time: '2024年7月31日 10:00', title: '「香港电影经典回顾」专题新增20部经典港片', tag: '片源更新' },
  { id: 7, time: '2024年7月30日 18:00', title: '《莲花楼》全集上线，成毅武侠新作口碑爆棚', tag: '新片上线' },
  { id: 8, time: '2024年7月30日 12:00', title: '移动端APP 3.2.0版本发布，新增离线下载和投屏功能', tag: '版本更新' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '极速播放零卡顿',
    desc: '智能CDN加速与自适应码率技术，全国多节点部署，无论何时何地都能享受不缓冲的流畅观影体验，高清蓝光画质随意切换。',
  },
  {
    id: 2,
    icon: 'ri-movie-2-line',
    title: '海量片源每日更新',
    desc: '覆盖国产剧、欧美大片、日韩热剧、动漫综艺等全品类，每日300+片源更新，热门影视第一时间上线，追剧永不掉队。',
  },
  {
    id: 3,
    icon: 'ri-device-line',
    title: '全平台无缝观影',
    desc: '支持电脑、平板、手机全终端观看，APP支持离线缓存与投屏播放，画中画模式让您边看边聊，随时随地畅享影视盛宴。',
  },
];